<template lang='pug'>
div
    PDMSelectorLinks
    div.fullwidth(v-if="$route.params.lang == 'en'")

        div.title-container
            h1.product-title PDM-80
            h2.product-subtitle 8-channel Partial Discharge Monitoring System

        div.margin-bottom
            .column-container
                .column.center-content
                    picture.flex-center-content
                        source(type='image/webp', srcset='@/assets/photos/PDM-80.webp')
                        img( src='@/assets/photos/PDM-80.png', width="100%", alt='PD Monitoring System PDM-80', title='PD Monitoring System PDM-80')
                .column.factsandbluebox
                    .factbox
                        span.headline Key Features:
                        ul
                            li Electrical PD monitoring system 
                            li Measurement and calibration conforming to IEC&nbsp60270
                            li 8 multiplexed input channels
                            li Connects to various PD sensor types (bushing tap sensors, measurement impedance, coupling capacitor)
                            li 1° resolution in PRPD view for 50 Hz and 60 Hz systems
                            li Platform-independent web GUI for high-resolution PRPD visualization and historical PD data analysis
                    .bluebox
                        //- Downloadlink(text='Datenblatt (pdf, deutsch)', link="/pdf/Datenblatt PDM-80.pdf")
                        Downloadlink(text='Datasheet (pdf, english)', link="/pdf/Datasheet PDM-80.pdf")
                        Maillink(to='support@bss-hs.de', sub='PDM-80', text='Contact Us', size=30, strokeWidth=2)
                        Sitelink(to="/en/products/electricalpdsensors/overview", text='Electrical PD Sensors')
                        Sitelink(to="/en/products/cal-iec", text='CAL-IEC PD Calibrator')
                    
        div.margin-bottom
            p The PDM-80 is a PD monitoring system for the electrical measurement of partial discharges according to IEC&nbsp60270. It is suitable for usage with measurement impedances, capacitive sensors or high-frequency current sensors. With 8 channels, it is ideal for the continuous monitoring of critical electrical installations like medium-voltage switchgear, cables, or transformers.
            p It can be calibrated according to IEC&nbsp60270.
            p The PDM-80 can communicate via included ModbusTCP, IEC&nbsp61850, HTTP API and two relay contacts. It has an integrated platform-independent web GUI for high-resolution phase resolved PD pattern (PRPD) visualization and historical PD data analysis.

        //- div.margin-bottom
        //-     p The BSS Monitoring Server provides a platform-independent graphical user interface for the PDM-600 with PRPDs, trend views and overview with all PD levels directly on the dashboard.
        //-     .column-container
        //-         .column.center-content
        //-             img( src='@/assets/photos/PDM-600 PRPD 3devices.png', width="100%", alt='Responsive PRPD-view on PDM-600', title='Responsive PRPD-view on PDM-600')
        //-         .column.center-content
        //-             img( src='@/assets/photos/PDM-600 2views 2devices.png', width="100%", alt='PD-level and trend-view on PDM-600', title='PD-level and trend-view on PDM-600')  



    //- Deutsche Version:
    div.fullwidth(v-if="$route.params.lang == 'de'")

        div.title-container
            h1.product-title PDM-80
            h2.product-subtitle 8-kanaliges Teilentladungs-Monitoring-System

        section.margin-bottom
            .column-container
                .column.center-content
                    picture.flex-center-content
                        source(type='image/webp', srcset='@/assets/photos/PDM-80.webp')
                        img( src='@/assets/photos/PDM-80.png', width="100%", alt='TE-Monitoring-System PDM-80', title='TE-Monitoring-System PDM-80')
                .column.factsandbluebox
                    .factbox
                        span.headline Highlights:
                        ul
                            li Elektrisches TE-Monitoring-System 
                            li IEC&nbsp60270-konforme TE-Messung und Kalibrierung
                            li 8 Eingangskanäle in Multiplexing
                            li 1°-genaue PRPD Auflösung bei 50 Hz und 60 Hz
                            li Anschlussmöglichkeit für alle gängigen TE-Sensortypen (Ankoppelvierpole, Durchführungssensoren, Koppelkondensatoren)
                            li Plattformunabhängige Web-GUI für hochauflösende PRPD-Darstellung und historische TE-Datenauswertung
                    .bluebox
                        //- Downloadlink(text='Datenblatt (pdf, deutsch)', link="/pdf/Datenblatt PDM-80.pdf")
                        Downloadlink(text='Datenblatt (pdf, englisch)', link="/pdf/Datasheet PDM-80.pdf")
                        Maillink(to='support@bss-hs.de', sub='PDM-80', text='Kontakt', size=30, strokeWidth=2)
                        Sitelink(to="/de/products/electricalpdsensors/overview", text='Elektrische TE-Sensoren')
                        Sitelink(to="/de/products/cal-iec", text='CAL-IEC TE-Kalibrator')
            
        div.margin-bottom
            p Das PDM-80 ist ein TE-Monitoring-System für die elektrische Messung von Teilentladungen nach IEC&nbsp60270. Es ist für den Einsatz mit Ankoppelvierpolen, kapazitiven Sensoren oder HFCT-Stromsensoren geeignet. Mit 8 Kanälen ist es ideal für die kontinuierliche Überwachung von kritischen elektrischen Anlagen wie Mittelspannungsschaltanlagen, Energiekabeln oder Transformatoren.
            p Es kann gemäß IEC&nbsp60270 kalibriert werden.
            p Das PDM-80 kann über ModbusTCP, IEC&nbsp61850, HTTP API und zwei Relaisausgänge kommunizieren und verfügt über eine plattformunabhängige Web-GUI für hochauflösende TE-Muster-Darstellung und historische TE-Datenauswertung.

        //- p Der BSS Monitoring Server bietet eine plattformunabhängige grafische Benutzeroberfläche für das PDM-600 mit PRPDs, Trendansichten und einer Übersicht mit allen TE-Pegeln direkt auf dem Dashboard.
        //- .column-container
        //-     .column.center-content
        //-         img( src='@/assets/photos/PDM-600 PRPD 3devices.png', width="100%", alt='PRPD-Ansicht des PDM-600', title='PRPD-Ansicht des PDM-600')
        //-     .column.center-content
        //-         img( src='@/assets/photos/PDM-600 2views 2devices.png', width="100%", alt='TE-Pegel und Trend-Ansicht des PDM-600', title='TE-Pegel und Trend-Ansicht des PDM-600')  
</template>

<script>
export default {
    meta: {
        de: {
            title: "BSS | PDM-80",

            description:
                "8-kanaliges Teilentladungs-Monitoring-System",
        },
        en: {
            title: "BSS | PDM-80",
            description:
                "8-channel Partial Discharge Monitoring System",
        },
    },
};
</script>